module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'tuugr6ix',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
